import { render, staticRenderFns } from "./textarea-widget.vue?vue&type=template&id=53db5232&scoped=true&"
import script from "./textarea-widget.vue?vue&type=script&lang=js&"
export * from "./textarea-widget.vue?vue&type=script&lang=js&"
import style0 from "./textarea-widget.vue?vue&type=style&index=0&id=53db5232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53db5232",
  null
  
)

export default component.exports